import apiFetch from '../../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'Entity/GetAllCountries', method: 'GET', token: token })
}
